export default () => ({
	selectedTab: 0,
	init() {
		if(window.location.hash.indexOf('orders') > -1) {
			this.selectedTab = 1;
		}
	},
	onTabClicked(tabIndex) {
		this.selectedTab = tabIndex;

		// send global event
		window.dispatchEvent(new CustomEvent('selectionsTabChanged', {
			detail: { tabIndex: this.selectedTab }
		}));
	},

});